import getExperimentInfoDetails, {
  ExperimentInfo,
} from '../ExperimentInfo/ExperimentInfo';
import {
  ExperimentImagingScheduleDTO,
  ExperimentImagingScheduleEntryDTO,
  ExperimentInfoImagingScheduleDTO,
} from 'business/models/Models';
export class ImagingScheduleData extends ExperimentInfoImagingScheduleDTO {
  private isDirty = false;

  setImagingScheduleDetails(
    selectedScheduleId: number,
    imagingSchedules: ExperimentImagingScheduleDTO[],
    headers: string[],
    enteries: ExperimentImagingScheduleEntryDTO[],
  ) {
    this.selectedImagingScheduleId = selectedScheduleId;
    this.imagingSchedules = imagingSchedules;
    this.headers = headers;
    this.imagingScheduleEntries = enteries;
  }
  set IsDirty(isDirty: boolean) {
    this.isDirty = isDirty;
  }
  get IsDirty() {
    return this.isDirty;
  }
}

const schedules: ImagingScheduleData = new ImagingScheduleData();
const experimentInfo: ExperimentInfo = getExperimentInfoDetails();

export function setImagingScheduleDetails(
  selectedScheduleId: number,
  imagingSchedules: ExperimentImagingScheduleDTO[],
  headers: string[],
  enteries: ExperimentImagingScheduleEntryDTO[],
) {
  schedules.setImagingScheduleDetails(
    selectedScheduleId,
    imagingSchedules,
    headers,
    enteries,
  );
}

export function setIsDirty(isDirty: boolean) {
  schedules.IsDirty = isDirty;
}

export function setExpInfoIsDirty(isDirty: boolean) {
  experimentInfo.IsDirty = isDirty;
}

export function getIsDirty() {
  return schedules.IsDirty || experimentInfo.IsDirty;
}

export function getImageSchedulesIsDirty() {
  return schedules.IsDirty;
}

export function getExperimentInfoIsDirty() {
  return experimentInfo.IsDirty;
}

export function getImagingScheduleDetails() {
  return schedules;
}
